/**
 * WordPress dependencies
 */
import { SelectControl, TextControl } from '@wordpress/components';
import { __ } from '@wordpress/i18n';
import { Fragment } from '@wordpress/element';
import { addFilter } from '@wordpress/hooks';
import { select } from '@wordpress/data';
import { createHigherOrderComponent } from '@wordpress/compose';

/**
 * External dependencies
 */
import { isEmpty, replace } from 'lodash';

/**
 * Inner dependencies.
 */
import { updateBlockStyle } from './inline-styles';
import Accordion from '../../components/Accordion';
import AnimationDropDown from '../../components/animation-dropdown';

// Enable on the following blocks
const enabledBlocks = [
	// 'core/button',
	// 'core/buttons',
	// 'core/group',
	// 'gutenify/gallery-carousel',
	// 'gutenify/map',
	// 'gutenify/container',
	// 'gutenify/buttons',
	// 'gutenify/button',
	// 'gutenify/icon',
	// 'gutenify/info-box',
	// 'gutenify/service',
	// 'gutenify/section-title',
	// 'gutenify/star-rating',
	// 'gutenify/testimonial',
	// 'gutenify/testimonials',
	// 'gutenify/team-member',
	// 'gutenify/team',
	// 'gutenify/post-carousel',
	// 'gutenify/slide-item',
	// 'gutenify/faqs',
	// 'gutenify/content-toggle-item',
];

const addAnimationFields = ( content, props ) => {
	const { attributes, setAttributes } = props;
	const { blockAdvanceOptions } = attributes;
	const {
		entranceAnimation = '',
		entranceAnimationDuration = 'normal',
		entranceAnimationDelay = '',
	} = blockAdvanceOptions;
	return [
		...content,
		<Fragment key={ `gutenify-block-common-options-tab-content-basic` }>
			<Accordion
				tabs={ [
					{
						name: 'button',
						initialOpen: true,
						label: () => {
							return __( 'Motion Effect' );
						},
						cb: () => {
							return (
								<>
									<AnimationDropDown
										label={ __( 'Entrance Animation' ) }
										onChange={ ( val ) => {
											const data = {
												blockAdvanceOptions: {
													...blockAdvanceOptions,
													entranceAnimation: val,
												},
											};
											setAttributes( data );
											updateBlockStyle( data, props );
										} }
										value={ entranceAnimation }
									/>
									{ entranceAnimation && (
										<>
											<SelectControl
												label={ __( 'Animation Duration' ) }
												onChange={ ( val ) => {
													const data = {
														blockAdvanceOptions: {
															...blockAdvanceOptions,
															entranceAnimationDuration: val,
														},
													};
													setAttributes( data );
													// updateBlockStyle( data, props );
												} }
												value={ entranceAnimationDuration }
												options={ [
													{ value: 'slow', label: __( 'Slow' ) },
													{ value: 'normal', label: __( 'Normal' ) },
													{ value: 'fast', label: __( 'Fast' ) },
												] }
											/>

											<TextControl
												label={ __( 'Animation Delay (ms)' ) }
												onChange={ ( val ) => {
													const data = {
														blockAdvanceOptions: {
															...blockAdvanceOptions,
															entranceAnimationDelay: val,
														},
													};
													setAttributes( data );
													updateBlockStyle( data, props );
												} }
												value={ entranceAnimationDelay }
												min={ 0 }
											/>
										</>
									) }
								</>
							);
						},
					},
				] }
			/>
		</Fragment>,
	];
};

// const hookPrefixes = [ 'button' ];

enabledBlocks.forEach( ( name ) => {
	const hookPrefix = replace( name, 'gutenify/', '' );
	addFilter( `gutenify-block-${ hookPrefix }-options-tab-advance`, `Gutenify/Block/${ hookPrefix }/InspectorControls/BasicControls/tabs/advance`, addAnimationFields );
} );

const withAnimtionClassName = createHigherOrderComponent( ( BlockListBlock ) => {
	return ( props ) => {
		if ( ! enabledBlocks.includes( props.name ) ) {
			return <BlockListBlock { ...props } />;
		}
		const { attributes } = props;
		const { blockAdvanceOptions } = attributes;
		const {
			entranceAnimation = '',
		} = blockAdvanceOptions;

		const customClass = entranceAnimation ? 'gutenify--animation--' + entranceAnimation : '';

		return <BlockListBlock { ...props } className={ customClass } />;
	};
}, 'withAnimtionClassName' );

addFilter( 'editor.BlockListBlock', 'your-plugin/your-custom-class', withAnimtionClassName );

const addAnimationClassName = ( saveElementProps, blockType, attributes ) => {
	// Do nothing if it's another block than our defined ones.
	if ( ! enabledBlocks.includes( blockType.name ) ) {
		return saveElementProps;
	}

	if ( ! isEmpty( select( 'core/editor' ).getCurrentPostType() ) ) {
		const result = saveElementProps.className.split( ' ' );
		const { blockAdvanceOptions } = attributes;
		const {
			entranceAnimation = '',
		} = blockAdvanceOptions;

		let blockAttrs = {};

		if ( '' !== entranceAnimation ) {
			const className = 'gutenify--invisible';
			if ( ! result.includes( className ) ) {
				result.push( className );
			}
			blockAttrs = `{ _animation: "${ entranceAnimation }", }`;
		}

		saveElementProps.className = result.join( ' ' );
		saveElementProps[ 'data-setting' ] = blockAttrs;
	}

	return saveElementProps;
};

addFilter( 'blocks.getSaveContent.extraProps', 'extend-block-example/get-save-content/extra-props', addAnimationClassName );
